import React from "react";
import { Popover, ConfigProvider } from "antd";

import { Colors } from "../../config";

const DefaultPopover = ({
  content,
  placement = "leftTop",
  title = null,
  trigger = "click",
  children,
  ...props
}) => {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorBgElevated: Colors.main,
          colorText: "white",
          controlItemBgHover: Colors.LightSecondary,
        },
      }}
    >
      <Popover
        placement={placement}
        title={title ?? null}
        content={content}
        arrow={{ pointAtCenter: true }}
        trigger={trigger}
      >
        {children}
      </Popover>
    </ConfigProvider>
  );
};

export default DefaultPopover;
